import React, { useEffect, useRef, useState } from 'react';
import ResizeObserver from 'resize-observer-polyfill';
import styled from 'styled-components';
import { pulse } from '../../styles/variables';
import { Animations } from '../../config/models';
import { AnimationClip } from 'three';

export function usePrevious(value: any) {
    const ref = useRef();
    useEffect(() => void (ref.current = value), [value]);
    return ref.current;
}

export function useMeasure() {
    const ref = useRef<any>();
    const [bounds, set] = useState({ left: 0, top: 0, width: 0, height: 0 });
    const [ro] = useState(() => new ResizeObserver(([entry]) => set(entry.contentRect)));
    useEffect(() => {
        if (ref.current) {
            ro.observe(ref.current);
        }
        return () => ro.disconnect();
    }, []);
    return [{ ref }, bounds];
}

export const PulsingMarker = styled.span`
    animation: ${pulse} 2s infinite;
    display: block;
    border-radius: 50%;
    cursor: pointer;
`;

export const transformAnimations = (animations: Animations | AnimationClip[]): Animations => {
    if (Array.isArray(animations)) {
        const finalAnimations: Animations = {};
        animations.forEach(animation => {
            finalAnimations[animation.name] = animation as any;
        });
        return finalAnimations;
    } else {
        return animations;
    }
};
